import { getProviderManager } from 'modules/core';

import { api } from '../api';
import { cacheTags } from '../cacheTags';

export const {
  useGetAccountAddressQuery,
  endpoints: { getAccountAddress },
} = api.injectEndpoints({
  endpoints: build => ({
    getAccountAddress: build.query<string, void>({
      queryFn: async () => {
        const instance = await getProviderManager();
        const provider = await instance.getETHWriteProvider();

        return { data: provider.currentAccount };
      },
      providesTags: [cacheTags.account],
    }),
  }),
});
